import styled from "styled-components";

interface OpenModalProp {
  $isOpended?: boolean;
}
export const MainWrap = styled.header`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 0;
  z-index: 10000;
  position: fixed;
  top: 0;
`;

export const LogoImageDiv = styled.div`
  position: relative;
  width: 44px;
  height: 44px;
  background: white;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  img {
  }
`;

export const LogoImage = styled.img`
  z-index: 1;
  position: absolute;
  width: 80%;
  height: 80%;
  object-fit: cover;
  :hover {
    transition: all 0.6s;
  }
`;

export const MainHead = styled.nav<OpenModalProp>`
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.36s;
  .nav-container {
    transition: all 1s;

    background: #050505;
    border: 1px solid #ffffff14;
    width: 100%;
    border-radius: 20px;
    gap: 20px;
    max-width: ${(p) => (p.$isOpended ? "620px" : "600px")};
    flex: 1;
    max-height: ${(p) => (p.$isOpended ? "1000px" : "64px")};
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: ${(p) => (p.$isOpended ? "20px" : "10px")};
  }
  .nav-holder {
    flex-flow: row;
    flex: none;
    place-content: center space-between;
    align-items: center;
    width: 100%;
    height: min-content;
    display: flex;
    position: relative;
    overflow: visible;
  }
  .links-container {
    transition: all 0.8s;
    width: 100%;

    display: ${(p) => (p.$isOpended ? "flex" : "none")};
    opacity: ${(p) => (p.$isOpended ? "1" : "1")};
    max-height: ${(p) => (p.$isOpended ? "1000px" : "0px")};


    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
  }
  .row-item {
    flex: 1;
    height: min-content;
    width: 1px;
    flex-flow: column;
    place-content: center;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    position: relative;
    overflow: visible;
  }
  .row-item-header {
    user-select: none;
    > h6 {
      margin: 0;
      font-size:18px;
      font-weight:500;
    }
  }
    .row-item,.row-item-header{
    flex:1;
    width:100%;
    text-align:left;

    }

  @media (max-width: 728px) {
  }

  @media (max-width: 450px) {
   .links-container {
   
    flex-wrap:wrap;
  }
    .row-item {
    min-width:180px;
  }

  }
`;

export const HeaderBtn = styled.div<OpenModalProp>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: #ffffff14;
  border: 1px solid #ffffff14;
  gap: 4px;
  cursor: pointer;
  width: 44px;
  height: 44px;
  padding: 4px;
  .wrapper {
    width: 20px;
    height: 20px;
    position: relative;
    transition: all 0.3s;
    transform: rotate(${(p) => (p.$isOpended ? "45deg" : "0deg")});
    div {
      position: absolute;
    }
  }
  .wrapper > :nth-child(1) {
    height: 2px;
    width: 100%;
    position: absolute;
    top: calc(50% - 1px);
    left: 0;
    right: 0;
    overflow: hidden;
    background: white;
  }

  .wrapper > :nth-child(2) {
    background: white;
    width: 2px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(50% - 1px);
    overflow: hidden;
  }
`;
